var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './ProgressIndicator.module.css';
export const ProgressIndicator = ({ ariaLabel, ariaLabelledBy, 'data-testid': testId, max, value, }) => {
    return (_jsx("progress", { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, className: styles.Container, "data-testid": testId, max: max, value: value }));
};
_react_refresh_temp_1 = ProgressIndicator;
$RefreshReg$(_react_refresh_temp_1, "ProgressIndicator");
